import React, {Component} from 'react';
import {Route, Routes} from 'react-router-dom';
import {HistoryRouter as Router} from 'redux-first-history/rr6';
import {connect} from 'react-redux';
import moment from 'moment';
import {es} from 'moment/locale/es';
import {history} from './common/store';
import {paths} from './common/dictionaries/urls';
import {displayRoutes} from './common/util/routes';
import AccessDenied from './common/components/accessDenied/';
import MessageBox from './common/messageBox/components';
import LoadingPage from './common/components/loadingPage';
import UnderConstruction from './common/components/errorPages/underConstruction';
import AppBar from './common/components/appBar/index';
import Dashboard from './dashboard/components';
import OriginsList from './origin/components/list';
import EditOrigin from './origin/components/edit';
import BackOrdersReport from './backOrders/components/report';
import MonthClose from './monthClose/components/index';
import ProvidersList from './provider/components/list';
import EditProvider from './provider/components/edit';
import LogisticAreas from './logisticAreas/components/list/index';
import {partRoutes} from './part/components/routes';
import {accesoriesRoutes} from './accessories/components/routes';
import {specialPartsRoutes} from './specialParts/components/routes';
import {providerOrdersRoutes} from './providerOrders/components/routes';
import {warehouseDenialCausesRoutes} from './picking/components/routes';
import {stockAdjustmentRoutes} from './stockAdjustment/components/routes';
import {warehousesRoutes} from './warehouses/components/routes';
import {dealerOrdersRoutes} from './dealerOrders/components/routes';
import {IccMatrixRoutes} from './iccMatrix/component/routes';
import {binningRoutes} from './binning/components/routes';
import {setsRoutes} from './sets/components/routes';
import {priceFactorsRoutes} from './priceFactors/components/routes';
import {partNumberCodeRoutes} from './partNumberCode/components/routes';
import {qualityAssuranceOrdersRoutes} from './qualityAssuranceOrders/components/routes';
import {formsRoutes} from './forms/components/routes';
import {partsReturnsRoutes} from './partsReturns/components/routes';
import {kpisRoutes} from './kpis/components/routes';
import {waitHappyRoutes} from './waitHappy/components/routes';
import {liquidationsRoutes} from './liquidations/components/routes';
import {warrantiesRoutes} from './warranties/components/routes';
import {campaignRoutes} from './campaign/routes';
import {twcMaintenanceRoutes} from './twcMaintenance/components/routes';
import ParametersList from './parameter/components/list';
import ParametersForm from './parameter/components/edit/form';
import UsersList from './users/components/list';
import UsersEdit from './users/components/edit';
import WarehouseTransfer from './transfers/components';
import ItemBudget from './itemBudget/components';
import PartsMaster from './partsMaster/components/form';
import PartsSalesList from './partsSales/components/list';
import LubricantsInvoicing from './lubricants/components/index';
import MasterVehicleFormEdit from './masterVehicle/components/form';
import PartsCatalog from './partsCatalog/components/fileLoader';
import InvoicesList from './partInvoices/components/invoicesList';
import FileInvoices from './partInvoices/components/fileInvoices';
import PrioritizationIndicesReport from './logisticsReports/component/prioritizationIndices';
import LogisticsIndicesReport from './logisticsReports/component/logisticIndices';
import DailyVehiclesSalesAndStock from './dailyVehiclesSalesAndStock/components/report';
import DailyVehiclesSalesAndStockWholesale from './dailyVehiclesSalesAndStockWholesale/components/report';
import DailyVehiclesSalesAndStockSummary from './dailyVehiclesSalesAndStockSummary/components/report';
import SearchCombosVehicles from './vehicleCombos/components/searchByChassis';
import VehiclesAvailability from './vehiclesAvailability/components/list';
import SalesAndBudgetsLoad from './salesAndBudgetsLoad/components/index';
import VehiclesSalesDetail from './vehiclesKpi/components/salesDetail';
import WholeSalePlanned from './wholeSale/components/wholeSalePlanned';
import VehiclesEfficiency from './vehicleEfficiency/components/list';
import ObsolescenceParams from './obsolescenceParameters/components';
import IccCharBytLetters from './iccChart/components/chartByLetters';
import ReportCombos from './vehicleCombos/components/reportCombos';
import ComboTasks from './logisticsOrders/components/comboTasks';
import TdeCalendarDetail from './calendar/component/monthDetail';
import ServiceReportPart from './serviceReportPart/components';
import InvoiceLoad from './invoiceLoad/components/edit/index';
import VehiclesKpi from './vehiclesKpi/components/report';
import VehiclesHistory from './vehicleHistory/components';
import InvoiceQuery from './invoiceQuery/components/list';
import MailGroupList from './mailGroup/components/list';
import MailGroupEdit from './mailGroup/components/edit';
import PartQuotation from './partQuotation/components';
import PartAudit from './partAudit/components/index';
import TdeCalendar from './calendar/component';
import BoReport from './boReport/components';
import VehAudi from './vehAudi/components';
import MasterVehicleList from './masterVehicle/components/list';
import {bulletinRoutes} from './bulletins/components/routes';
import {twcConsultyRoutes} from './twcConsulty/components/routes';
import {adminWarrantyRoutes} from './adminWarranty/components/routes';
import {budgetVehiclesRoutes} from './budgetVehicles/components/routes';
import {technicianGroupRoutes} from './logisticTechnicians/components/routes';
import {vehicleSaleForecastRoutes} from './vehicleSaleForecast/components/routes';
import {vehicleCertificationRoutes} from './vehicleCertification/components/routes';
import {anticipatedInvoiceVehiclesRoutes} from './anticipatedInvoiceVehicles/components/routes';
import {dispatchOrdersRoutes} from './dispatchOrders/components/routes';
import {devicesRoutes} from './devices/components/routes';
import {manageOrdersRoutes} from './manageOrders/components/routes';
import {vehiclesInventoryRoutes} from './vehiclesInventory/components/routes';
import {partsImportsRoutes} from './partsImports/components/routes';
import {accessoriesRequestsRoutes} from './accessoriesRequests/components/routes';
import {combosRoutes} from './combos/routes';
import {transportistRoutes} from './transportist/routes';
import {agenciesRoutes} from './agencies/routes';
import LogisticModels from './logisticModels/components';
import LogisticTasks from './logisticTasks/components';
import {vehiclesPriorizationRoutes} from './vehiclesPriorization/components/routes';
import {customerTrackingRoutes} from './customerTracking/components/routes';
import {floatingInventoryRoutes} from './floatingInventory/components/routes';
import {accountReporterRoutes} from './accountReporter/components/routes';
import {wtsRoutes} from './wts/routes';
import './App.scss';
import CommercialUsers from './commercialUsers';
import ReportPartsSalesJapan from './reportPartsSalesJapan/components/reportCombos';
import {PartsLocationDashboard} from './partsLocationDashboard/components/routes';
import Turnstile from './Turnstile';

class App extends Component {
  componentDidMount() {
    moment.locale(es);
  }

  renderAppBar() {
    const {isMenuHidden} = this.props;
    if (isMenuHidden) {
      return null;
    }
    return <AppBar />;
  }

  render() {
    const {rehydrated} = this.props;
    if (!rehydrated) {
      return <LoadingPage />;
    }
    const path = history.location.pathname;
    const pickingDashboardClass =
      path === paths.PickingDashboard ? 'picking-dashboard-content' : '';
    const liquidationsClass =
      path === paths.LiquidationsList ||
      path.includes('/liquidaciones/detalle/') ?
        'liquidations-content' :
        '';

    return (
      <Router history={history}>
        <div className='App'>
          <Turnstile />
          <MessageBox />
          {this.renderAppBar(this)}
          <div className='App-layout'>
            <div className='App-body'>
              <div
                className={`App-content ${pickingDashboardClass} ${liquidationsClass}`}
              >
                <Routes>
                  <Route path={paths.Home} element={<Dashboard />} />
                  <Route path='/cargando' element={<LoadingPage />} />
                  <Route path={paths.CommercialUsers} element={<CommercialUsers />} />
                  <Route path={paths.AccessDenied} element={<AccessDenied />} />
                  <Route
                    path={paths.ProvidersList}
                    element={<ProvidersList />}
                  />
                  <Route path={paths.EditProvider} element={<EditProvider />} />
                  <Route
                    path={paths.SeeEditProvider}
                    element={<EditProvider />}
                  />
                  <Route path={paths.OriginsList} element={<OriginsList />} />
                  <Route path={paths.EditOriginNew} element={<EditOrigin />} />
                  <Route path={paths.EditOrigin} element={<EditOrigin />} />
                  <Route
                    path={paths.ParametersList}
                    element={<ParametersList />}
                  />
                  <Route
                    path={paths.ParametersEdit}
                    element={<ParametersForm />}
                  />
                  <Route
                    path={paths.ParametersNew}
                    element={<ParametersForm />}
                  />
                  <Route path={paths.UsersList} element={<UsersList />} />
                  <Route
                    path={paths.UsersRequestEdit}
                    element={<UsersEdit />}
                  />
                  <Route path={paths.UsersRequestNew} element={<UsersEdit />} />
                  <Route path={paths.UsersEdit} element={<UsersEdit />} />
                  <Route path={paths.UsersNew} element={<UsersEdit />} />
                  <Route path={paths.MonthClose} element={<MonthClose />} />
                  <Route
                    path={paths.BackOrdersReport}
                    element={<BackOrdersReport />}
                  />
                  <Route
                    path={paths.WarehouseTransfer}
                    element={<WarehouseTransfer />}
                  />
                  <Route path={paths.ItemBudget} element={<ItemBudget />} />
                  <Route path={paths.PartsMaster} element={<PartsMaster />} />
                  <Route
                    path={paths.LubricantsInvoicing}
                    element={<LubricantsInvoicing />}
                  />
                  <Route
                    path={paths.SalesAndBudgetsLoad}
                    element={<SalesAndBudgetsLoad />}
                  />
                  <Route
                    path={paths.PartQuotation}
                    element={<PartQuotation />}
                  />
                  <Route path={paths.InvoiceLoad} element={<InvoiceLoad />} />
                  <Route
                    path={paths.EditInvoiceLoad}
                    element={<InvoiceLoad />}
                  />
                  <Route path={paths.SmByicc} element={<IccCharBytLetters />} />
                  <Route path={paths.PartsCatalog} element={<PartsCatalog />} />
                  <Route
                    path={paths.PartsSalesList}
                    element={<PartsSalesList />}
                  />
                  <Route
                    path={paths.ObsolescenceParams}
                    element={<ObsolescenceParams />}
                  />
                  <Route path={paths.InvoicesList} element={<InvoicesList />} />
                  <Route path={paths.InvoiceQuery} element={<InvoiceQuery />} />
                  <Route path={paths.FileInvoices} element={<FileInvoices />} />
                  <Route path={paths.PartAudit} element={<PartAudit />} />
                  <Route path={paths.ComboTasks} element={<ComboTasks />} />
                  <Route
                    path={paths.PrioritizationIndices}
                    element={<PrioritizationIndicesReport />}
                  />
                  <Route
                    path={paths.VehiclesAvailability}
                    element={<VehiclesAvailability />}
                  />
                  <Route path={paths.TdeCalendar} element={<TdeCalendar />} />
                  <Route
                    path={paths.TdeCalendarDetail}
                    element={<TdeCalendarDetail />}
                  />
                  <Route path={paths.BoReport} element={<BoReport />} />
                  <Route
                    path={paths.MasterVehicleFormAdd}
                    element={<MasterVehicleFormEdit />}
                  />
                  <Route
                    path={paths.MasterVehUpdate}
                    element={<MasterVehicleFormEdit />}
                  />
                  <Route
                    path={paths.SearchCombosVehicles}
                    element={<SearchCombosVehicles />}
                  />
                  <Route path={paths.ReportCombos} element={<ReportCombos />} />
                  <Route
                    path={paths.ServiceReportPart}
                    element={<ServiceReportPart />}
                  />
                  <Route path={paths.VehAudi} element={<VehAudi />} />
                  <Route path={paths.ReportPartsSalesJapan} element={<ReportPartsSalesJapan />} />
                  <Route
                    path={paths.VehiclesEfficiency}
                    element={<VehiclesEfficiency />}
                  />
                  <Route path={paths.VehiclesKpi} element={<VehiclesKpi />} />
                  <Route
                    path={paths.VehiclesSalesDetail}
                    element={<VehiclesSalesDetail />}
                  />
                  <Route
                    path={paths.MasterVehicleList}
                    element={<MasterVehicleList />}
                  />
                  <Route
                    path={paths.VehiclesHistory}
                    element={<VehiclesHistory />}
                  />
                  <Route
                    path={paths.WholeSalePlanned}
                    element={<WholeSalePlanned />}
                  />
                  <Route
                    path={paths.LogisticIndices}
                    element={<LogisticsIndicesReport />}
                  />
                  <Route
                    path={paths.MailGroupList}
                    element={<MailGroupList />}
                  />
                  <Route
                    path={paths.MailGroupEdit}
                    element={<MailGroupEdit />}
                  />
                  <Route
                    path={paths.MailGroupNew}
                    element={<MailGroupEdit />}
                  />
                  <Route
                    path={paths.LogisticAreas}
                    element={<LogisticAreas />}
                  />
                  <Route
                    path={paths.DailyVehiclesSalesAndStockSummary}
                    element={<DailyVehiclesSalesAndStockSummary />}
                  />
                  <Route
                    path={paths.DailyVehiclesSalesAndStockWholesale}
                    element={<DailyVehiclesSalesAndStockWholesale />}
                  />
                  <Route
                    path={paths.DailyVehiclesSalesAndStockReport}
                    element={<DailyVehiclesSalesAndStock />}
                  />
                  {displayRoutes(technicianGroupRoutes)}
                  <Route path={paths.LogisticModels} element={<LogisticModels />} />
                  <Route path={paths.LogisticTasks} element={<LogisticTasks />} />
                  {displayRoutes(bulletinRoutes)}
                  {displayRoutes(adminWarrantyRoutes)}
                  {displayRoutes(twcMaintenanceRoutes)}
                  {displayRoutes(twcConsultyRoutes)}
                  {displayRoutes(campaignRoutes)}
                  {displayRoutes(warrantiesRoutes)}
                  {displayRoutes(waitHappyRoutes)}
                  {displayRoutes(qualityAssuranceOrdersRoutes)}
                  {displayRoutes(accountReporterRoutes)}
                  {displayRoutes(accesoriesRoutes)}
                  {displayRoutes(formsRoutes)}
                  {displayRoutes(partsReturnsRoutes)}
                  {displayRoutes(partNumberCodeRoutes)}
                  {displayRoutes(stockAdjustmentRoutes)}
                  {displayRoutes(priceFactorsRoutes)}
                  {displayRoutes(kpisRoutes)}
                  {displayRoutes(liquidationsRoutes)}
                  {displayRoutes(setsRoutes)}
                  {displayRoutes(specialPartsRoutes)}
                  {displayRoutes(binningRoutes)}
                  {displayRoutes(IccMatrixRoutes)}
                  {displayRoutes(warehousesRoutes)}
                  {displayRoutes(partRoutes)}
                  {displayRoutes(dealerOrdersRoutes)}
                  {displayRoutes(providerOrdersRoutes)}
                  {displayRoutes(warehouseDenialCausesRoutes)}
                  {displayRoutes(budgetVehiclesRoutes)}
                  {displayRoutes(vehicleSaleForecastRoutes)}
                  {displayRoutes(vehicleCertificationRoutes)}
                  {displayRoutes(anticipatedInvoiceVehiclesRoutes)}
                  {displayRoutes(dispatchOrdersRoutes)}
                  {displayRoutes(devicesRoutes)}
                  {displayRoutes(manageOrdersRoutes)}
                  {displayRoutes(vehiclesInventoryRoutes)}
                  {displayRoutes(partsImportsRoutes)}
                  {displayRoutes(accessoriesRequestsRoutes)}
                  {displayRoutes(combosRoutes)}
                  {displayRoutes(transportistRoutes)}
                  {displayRoutes(agenciesRoutes)}
                  {displayRoutes(vehiclesPriorizationRoutes)}
                  {displayRoutes(customerTrackingRoutes)}
                  {displayRoutes(floatingInventoryRoutes)}
                  {displayRoutes(PartsLocationDashboard)}
                  {displayRoutes(wtsRoutes)}
                  <Route exact path='*' element={<UnderConstruction />} />
                </Routes>
              </div>
            </div>
          </div>
        </div>
      </Router>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'rehydrated': state.rehydrate.rehydrate,
    'menuSelected': state.menu.selected,
    'isMenuHidden': state.menu.isHidden,
  };
};

export default connect(mapStateToProps)(App);
